import { render, staticRenderFns } from "./pageLayoutAllocation.vue?vue&type=template&id=6e2b3c37&scoped=true&"
import script from "./pageLayoutAllocation.vue?vue&type=script&lang=js&"
export * from "./pageLayoutAllocation.vue?vue&type=script&lang=js&"
import style0 from "./pageLayoutAllocation.vue?vue&type=style&index=0&id=6e2b3c37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b3c37",
  null
  
)

export default component.exports